'use strict';

export const TRANSFER_TYPE_OPTIONS = [
    {
        label: 'SFTP Active',
        value: 'SFTPACTIVE',
    },
    {
        label: 'SFTP Passive',
        value: 'SFTPPASSIVE',
    },
    {
        label: 'FTP Active',
        value: 'FTPACTIVE',
    },
    {
        label: 'FTP Passive',
        value: 'FTPPASSIVE',
    },
    {
        label: 'FTPS Passive',
        value: 'FTPSPASSIVE',
    },
]


// WEBPACK FOOTER //
// ./src/assets/js/constants/FTPConfigOptions.js